<template>
  <div>
    <div class="answer-info">
      <span>{{
        surveyQuestion?.optionType === "MULTIPLE_CHOICE"
          ? "Birden fazla yanıt seçebilirsiniz."
          : "Sadece bir yanıt seçebilirsiniz."
      }}</span>
    </div>
    <div class="radio-group">
      <div class="radio-group-question">
        <RadioButtonGroup
          :options="surveyQuestion?.surveyQuestionAnswers"
          :label-style="labelStyle"
          withLabel
          :selected="surveyQuestionAnswer.get(surveyQuestion?.id)"
          @select="handleSelectRadio(surveyQuestion.id, $event)"
          :multiSelect="surveyQuestion?.optionType === 'MULTIPLE_CHOICE'"
        />
      </div>
    </div>
    <div class="footer" :class="{ right: currentQuestionNumber === 1 }">
      <div class="prev" v-if="currentQuestionNumber !== 1">
        <AppButton
          secondary
          id="survey"
          title="Geri Dön"
          md
          @buttonClick="questionBackDirection"
        />
      </div>
      <div class="next">
        <AppButton
          primary
          id="survey"
          md
          :disabled="isNextButtonDisabled"
          :title="
            currentQuestionNumber === questionCount
              ? 'Anketi Tamamla'
              : 'Devam Et'
          "
          @buttonClick="questionNextDirection"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { AppButton } from "@n11/so-ui-components";
import { mapGetters, mapMutations, mapActions } from "vuex";
import RadioButtonGroup from "../common/RadioButtonGroup/RadioButtonGroup";

export default {
  name: "SurveyQuestionAnswers",
  components: {
    RadioButtonGroup,
    AppButton,
  },
  props: {
    surveyQuestion: Object,
    questionCount: Number,
    surveyId: [String, Number],
  },
  data() {
    return {
      labelStyle: {
        margin: "3px 0 3px 0",
        fontSize: "13px",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "1.38",
        letterSpacing: "-0.05px",
        color: "#1f1f1f",
      },
      selectedItems: [],
      surveyQuestionAnswer: new Map(),
      errorMessage: true,
    };
  },
  computed: {
    ...mapGetters({
      currentQuestionNumber: "surveys/getCurrentQuestionNumber",
    }),
    isNextButtonDisabled() {
      return !this.surveyQuestionAnswer.has(this.surveyQuestion.id);
    },
  },
  methods: {
    ...mapActions({
      requestSurveyAnswersFn: "surveys/requestSurveyAnswers",
    }),
    ...mapMutations({
      setCurrentQuestionNumberFn: "surveys/SET_CURRENT_QUESTION_NUMBER",
    }),
    questionNextDirection() {
      const questionAnswer = {
        surveyId: this.surveyId,
        answers: [],
      };

      if (this.surveyQuestionAnswer.has(this.surveyQuestion.id)) {
        this.errorMessage = true;
        if (this.currentQuestionNumber !== this.questionCount) {
          this.setCurrentQuestionNumberFn(++this.currentQuestionNumber);
        } else {
          this.surveyQuestionAnswer.forEach((value, key) => {
            JSON.parse(JSON.stringify(value)).forEach((item) => {
              const answer = {
                surveyQuestionId: key,
                surveyQuestionAnswerId: item,
              };
              questionAnswer.answers.push(answer);
            });
          });
          this.requestSurveyAnswersFn(questionAnswer);
        }
      } else {
        this.errorMessage = false;
      }
    },
    questionBackDirection() {
      this.setCurrentQuestionNumberFn(--this.currentQuestionNumber);
      this.errorMessage = false;
    },
    handleSelectRadio(surveyQuestionId, selectedItems) {
      if (JSON.parse(JSON.stringify(selectedItems)).length > 0) {
        this.surveyQuestionAnswer.set(surveyQuestionId, selectedItems);
        this.errorMessage = false;
      } else {
        this.surveyQuestionAnswer.delete(surveyQuestionId);
        this.errorMessage = true;
      }
      this.errorMessage = !this.surveyQuestionAnswer.has(surveyQuestionId);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/variables.scss";

.radio-group {
  width: 100%;
  min-height: 116px;
  overflow-y: auto;

  &-question {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 0 16px 12px 16px;

    span {
      margin: 3px 0 3px 12px;
      font-size: 13px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.38;
      letter-spacing: -0.05px;
      color: $dark-gray-5;
    }
  }

  .hr {
    margin: 12px 0 12px 54px;
  }
}
.footer {
  display: flex;
  justify-content: flex-end !important;
  margin-bottom: 24px;
  padding: 0 16px;
  gap: 8px;

  .prev {
    display: flex;
    align-items: center;
    cursor: pointer;

    span {
      font-size: 14px;
      font-weight: 600;
      color: $blue-5;
    }
  }

  .next {
    width: 100%;
    height: 40px;
    position: relative;
  }

  &.right {
    justify-content: flex-end !important;
    margin-bottom: 24px;
    padding: 0 16px;
  }
}

.answer-info {
  margin: 0 20px 18px 20px;

  span {
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: -0.05px;
    color: $dark-gray-5;
  }
}
</style>
